var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInstagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1400 1400",
    width: "48px",
    height: "48px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    cx: "50%",
    cy: "50%",
    r: "50%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(300, 300)",
    d: "M400 266.7C326.6 266.7 266.7 326.6 266.7 400C266.7 473.4 326.6 533.3 400 533.3C473.4 533.3 533.3 473.4 533.3 400C533.3 326.6 473.4 266.7 400 266.7ZM799.8 400C799.8 344.8 800.3 290.1 797.2 235C794.1 171 779.5 114.2 732.7 67.4C685.8 20.5 629.1 6.00001 565.1 2.90001C509.9 -0.199993 455.2 0.300008 400.1 0.300008C344.9 0.300008 290.2 -0.199993 235.1 2.90001C171.1 6.00001 114.3 20.6 67.5 67.4C20.6 114.3 6.09998 171 2.99998 235C-0.100018 290.2 0.399984 344.9 0.399984 400C0.399984 455.1 -0.100018 509.9 2.99998 565C6.09998 629 20.7 685.8 67.5 732.6C114.4 779.5 171.1 794 235.1 797.1C290.3 800.2 345 799.7 400.1 799.7C455.3 799.7 510 800.2 565.1 797.1C629.1 794 685.9 779.4 732.7 732.6C779.6 685.7 794.1 629 797.2 565C800.4 509.9 799.8 455.2 799.8 400ZM400 605.1C286.5 605.1 194.9 513.5 194.9 400C194.9 286.5 286.5 194.9 400 194.9C513.5 194.9 605.1 286.5 605.1 400C605.1 513.5 513.5 605.1 400 605.1ZM613.5 234.4C587 234.4 565.6 213 565.6 186.5C565.6 160 587 138.6 613.5 138.6C640 138.6 661.4 160 661.4 186.5C661.408 192.793 660.174 199.025 657.77 204.84C655.365 210.655 651.838 215.939 647.388 220.388C642.938 224.838 637.655 228.366 631.84 230.77C626.025 233.174 619.793 234.408 613.5 234.4Z",
    x: 500,
    y: 500,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram.29af667f.svg";
export { ForwardRef as ReactComponent };